import { makeStyles } from "tss-react/mui";

interface IParams {
    isWrapped?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    card: {
        boxShadow: "none",
        backgroundColor: theme.palette.background.main,
    },
    keepMePostedButton: {
        paddingBlock: 11,
        marginTop: props.isWrapped ? theme.spacing(3) : theme.spacing(5),
    },
    successIcon: {
        width: 29,
        height: 24,
    },
}));
